<template>
    <div class="steps">
        <h2 class="title">您激活的是「电脑版」</h2>
        <p class="tips">请下载电脑版完成配置</p>
        <el-button class="button" @click="isPC ? openDownloadPage() : ''">{{isPC ? '立即下载' : '请到电脑上下载'}}</el-button>
    </div>
</template>

<script>
import {} from "@/api/index";
import { Message } from "element-ui";
import {
    mapState
} from "vuex";
export default {
    data() {
        return {
        };
    },
    created() {},
    computed: {
        ...mapState({
            isPC: state => state.isPC,
        })
    },
    methods: {
        openDownloadPage() {
            window.open("https://www.xiaohudi.com/download.html")
        }
    }
};
</script>


